import React from 'react'
import {Card, CardHeader, Col, Form, FormGroup, Input, InputGroup, Modal,} from "reactstrap";
import Row from "reactstrap/es/Row";
// Strings
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {Redirect} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import {RotateCircleLoading} from "react-loadingg";
import {report_strings} from "../../translations/report_translations";
import CardBody from "reactstrap/es/CardBody";
import Button from "reactstrap/es/Button";
import businessApiService from "../../api/business-api-service";
import ErrorModal from "../Alerts/ErrorModal";
import ProBadge from "../Alerts/ProBadge";
import resourceHelper from "../../helpers/ResourceHelper";
import dateHelpers from "../../helpers/DateHelper";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);

const sectionStyle = {
    marginTop: 10,
    marginLeft: 20,
    marginBottom: 30,
    marginRight: 20,
    // boxShadow: "0 10px 10px rgba(0, 0, 0, 0.2)",
    borderRadius: 10,
    padding: 20,
}

export default class MessagingView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            filters: {
                app_invite_all_on: false,
                app_invite_active_on: true,
                to_all_active_on: true,
                to_all_all_on: false,
            },
            bd_settings: resourceHelper.emptyBdSettings(),
            classReminderSettings: resourceHelper.emptyClassReminderSettings(),
            classRegistrationSettings: resourceHelper.emptyClassRegistrationSettings(),
            welcome_email_settings: resourceHelper.emptyWelcomeSettings(),
            exp_ticket_settings: resourceHelper.emptyExpTicketsSettings(),
            message: {title: "", message: ""},
            bdSettingsChanged: false,
        };

        this.handleChange = this.handleChange.bind(this)
        this.handleMessageInputChange = this.handleMessageInputChange.bind(this)
        this.handleBdSettingsChange = this.handleBdSettingsChange.bind(this)
        this.handleClassReminderSettingsChange = this.handleClassReminderSettingsChange.bind(this)
        this.handleClassRegistrationSettings = this.handleClassRegistrationSettings.bind(this)

        window.MessagingView = this;
        this.getData()
    }

    goToClass = this.goToClass.bind(this);

    componentDidMount() {
        window.MessagingView = this
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    render() {
        this.localize();

        if (this.state.goToClassId) {
            return <Redirect from="*" to={{
                pathname: "/admin/class_overview",
                state: {yclassId: this.state.goToClassId}
            }}/>
        }

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                {this.state.showError && <ErrorModal showError={this.state.showError} error={this.state.error}
                                                     toggleErrorModal={() => this.toggleErrorModal()}/>}

                {this.state.showMessageModal === true &&
                    this.renderSendMessageModal()
                }

                {!this.state.messageSent &&
                    <Card className="shadow bg-default" style={sectionStyle}>
                        <div style={{color: "white"}}>
                            <h4 style={{color: "white"}}>{resourceStrings.cabinet.messaging_app_send_all_title}
                                <ProBadge/>
                            </h4>
                            <div
                                style={{color: "gray"}}>{resourceStrings.cabinet.messaging_app_send_all_expl}</div>

                            <div className="text-right">
                                <Button style={{marginTop: 20}} size="lg" color="warning"
                                        onClick={e => this.toggleMessageModal()}>{resourceStrings.cabinet.messaging_app_send_all_create}</Button>
                            </div>
                        </div>
                    </Card>
                }

                <Card className="shadow bg-default" style={sectionStyle}>
                    <div style={{color: "white"}}>
                        <h4 style={{color: "white"}}>{resourceStrings.cabinet.messaging_app_check_messages}
                        </h4>
                        <div
                            style={{color: "gray"}}>{resourceStrings.cabinet.messaging_app_check_messages_expl}</div>

                        {this.state.showMessageHistoryView &&

                            <div>
                                {(this.state.messages ?? []).length === 0 ?
                                    <div style={{marginTop: 10}}>{resourceStrings.cabinet.messaging_app_no_messages}</div>
                                    :
                                    <div style={{marginTop: 20, maxHeight: 400, overflowY: "scroll", maxWidth: 800}}>
                                        {this.state.messages.map(message => {
                                            return <div style={{display: "flex", flexFlow: "column", background: "white", color: "black", borderRadius: 10, padding: 12, margin: 6}} key={message.id}>
                                                <span style={{color: "gray", fontSize: "0.7rem", fontWeight: 600}}>{dateHelpers.formatDate(new Date(message.sent_at))}</span>
                                                <span style={{fontSize: "0.8rem", fontWeight: 600, marginTop: 10, marginBottom: 2}}>{message.title}</span>
                                                {message.body}
                                                <span style={{color: "gray", fontSize: "0.7rem", fontWeight: 600, marginTop: 10}}>{resourceStrings.cabinet.sent_to}: {message.student_ids.length} {commonStrings.navigation.clients.toLowerCase()}</span>
                                            </div>
                                        })}
                                    </div>
                                }
                            </div>
                        }

                        <div className="text-right">
                            <Button style={{marginTop: 20}} size="lg" color="warning"
                                    onClick={e => this.toggleMessageHistoryView()}> { this.state.showMessageHistoryView ? commonStrings.close : resourceStrings.cabinet.messaging_app_view_messages} </Button>
                        </div>
                    </div>
                </Card>

                {!this.state.appInviteSent &&
                    <Card className="shadow bg-default" style={sectionStyle}>
                        <div style={{color: "white"}}>
                            <h4 style={{color: "white"}}>{resourceStrings.cabinet.messaging_app_invite_title}</h4>
                            <div
                                style={{color: "gray"}}>{resourceStrings.cabinet.messaging_app_invite_expl}</div>

                            <div className="custom-control custom-control-alternative custom-checkbox"
                                 style={{marginTop: 10}}>
                                <input
                                    className="custom-control-input"
                                    id="input-app-invite-active-cb"
                                    color="success"
                                    checked={this.state.filters.app_invite_active_on}
                                    onChange={this.handleChange}
                                    type="checkbox"
                                />
                                <label className="custom-control-label" htmlFor="input-app-invite-active-cb">
                                    {resourceStrings.cabinet.messaging_app_invite_to_active}
                                </label>
                            </div>

                            <div className="custom-control custom-control-alternative custom-checkbox"
                                 style={{marginTop: 10}}>
                                <input
                                    className="custom-control-input"
                                    id="input-app-invite-all-cb"
                                    color="success"
                                    checked={this.state.filters.app_invite_all_on}
                                    onChange={this.handleChange}
                                    type="checkbox"
                                />
                                <label className="custom-control-label" htmlFor="input-app-invite-all-cb">
                                    {resourceStrings.cabinet.messaging_app_invite_to_all}
                                </label>
                            </div>

                            <div className="text-right">
                                <Button style={{marginTop: 20}} size="lg" color="warning"
                                        onClick={e => this.sendAppInviteMessage(e)}>{commonStrings.send_message}</Button>
                            </div>
                        </div>
                    </Card>
                }

                {this.state.appInviteSent &&
                    <div className="text-center text-white" style={{margin: 10}}>{commonStrings.message_sent}</div>
                }

                {this.state.messageSent &&
                    <div className="text-center text-white" style={{margin: 10}}>{commonStrings.message_sent}</div>
                }

                {/*Birthdays*/}
                {this.state.bd_settings &&
                    <Card className="shadow bg-default" style={sectionStyle}>
                        <div style={{color: "white"}}>
                            <h4 style={{color: "white"}}>{resourceStrings.cabinet.messaging_birthdays_title}</h4>
                            <div
                                style={{color: "gray"}}>{resourceStrings.cabinet.messaging_birthdays_expl}</div>

                            <div className="custom-control custom-control-alternative custom-checkbox"
                                 style={{marginTop: 10}}>
                                <input
                                    className="custom-control-input"
                                    id="input-bd-active-cb"
                                    color="success"
                                    checked={this.state.bd_settings.to_active}
                                    onChange={this.handleBdSettingsChange}
                                    type="checkbox"
                                />
                                <label className="custom-control-label" htmlFor="input-bd-active-cb">
                                    {resourceStrings.cabinet.messaging_app_invite_to_active}
                                </label>
                            </div>

                            <div className="custom-control custom-control-alternative custom-checkbox"
                                 style={{marginTop: 10}}>
                                <input
                                    className="custom-control-input"
                                    id="input-bd-all-cb"
                                    color="success"
                                    checked={this.state.bd_settings.to_all}
                                    onChange={this.handleBdSettingsChange}
                                    type="checkbox"
                                />
                                <label className="custom-control-label" htmlFor="input-bd-all-cb">
                                    {resourceStrings.cabinet.messaging_app_invite_to_all}
                                </label>
                            </div>

                            {(this.state.bd_settings.to_active || this.state.bd_settings.to_all) &&
                                <Row style={{marginTop: 12}}>
                                    <Col lg="12">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="input-description"
                                            >
                                                {resourceStrings.cabinet.message_to_active}
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-bd-message-to-active"
                                                onChange={this.handleBdSettingsChange}
                                                defaultValue={this.state.bd_settings.active_text}
                                                rows="2"
                                                type="textarea"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            }

                            {this.state.bd_settings.to_all &&
                                <Row>
                                    <Col lg="12">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="input-description"
                                            >
                                                {resourceStrings.cabinet.message_to_inactive}
                                            </label>
                                            <Input
                                                className="form-control-alternative"
                                                id="input-bd-message-to-inactive"
                                                onChange={this.handleBdSettingsChange}
                                                defaultValue={this.state.bd_settings.inactive_text}
                                                rows="2"
                                                type="textarea"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            }

                            <div className="text-right">
                                <Button style={{marginTop: 20}} size="lg" color="success"
                                        disabled={!this.canSaveBdSettings()}
                                        onClick={e => this.saveBdChanges(e)}>
                                    {commonStrings.save}
                                </Button>
                            </div>
                        </div>
                    </Card>
                }

                {/*Class reminders*/}
                {this.state.classReminderSettings &&
                    <Card className="shadow bg-default" style={sectionStyle}>
                        <div style={{color: "white"}}>
                            <h4 style={{color: "white"}}>{resourceStrings.cabinet.class_reminders_title}</h4>
                            <div
                                style={{color: "gray"}}>{resourceStrings.cabinet.class_reminders_expl}</div>

                            <div className="custom-control custom-control-alternative custom-checkbox"
                                 style={{marginTop: 10, marginBottom: 10}}>
                                <input
                                    className="custom-control-input"
                                    id="input-class-reminder-cb"
                                    color="success"
                                    checked={this.state.classReminderSettings.is_enabled}
                                    onChange={this.handleClassReminderSettingsChange}
                                    type="checkbox"
                                />
                                <label className="custom-control-label" htmlFor="input-class-reminder-cb">
                                <span
                                    style={this.state.classReminderSettings.is_enabled ? {color: "white"} : {color: "gray"}}> {commonStrings.enabled} </span>
                                </label>
                            </div>

                        </div>
                    </Card>
                }

                {/*Class registration*/}
                {this.state.classRegistrationSettings &&
                    <Card className="shadow bg-default" style={sectionStyle}>
                        <div style={{color: "white"}}>
                            <h4 style={{color: "white"}}>{resourceStrings.cabinet.class_registration_title} <ProBadge/>
                            </h4>
                            <div
                                style={{color: "gray"}}>{resourceStrings.cabinet.class_registration_expl}</div>

                            <div className="custom-control custom-control-alternative custom-checkbox"
                                 style={{marginTop: 10, marginBottom: 10}}>
                                <input
                                    className="custom-control-input"
                                    id="input-class-registr-cb"
                                    color="success"
                                    checked={this.state.classRegistrationSettings.is_enabled}
                                    onChange={this.handleClassRegistrationSettings}
                                    type="checkbox"
                                />
                                <label className="custom-control-label" htmlFor="input-class-registr-cb">
                                <span
                                    style={this.state.classRegistrationSettings.is_enabled ? {color: "white"} : {color: "gray"}}> {commonStrings.enabled} </span>
                                </label>
                            </div>

                        </div>
                    </Card>
                }

                {/*    CUSTOM MESSAGE   */}
                <Card className="shadow bg-default" style={sectionStyle}>
                    <div style={{color: "white"}}>
                        <FormGroup>
                            <div className="custom-control custom-checkbox mt-4"
                            >
                                <input
                                    className="custom-control-input"
                                    id="input-welcome-cb"
                                    type="checkbox"
                                    onChange={this.handleChange}
                                    checked={this.state.welcome_email_settings.is_enabled}
                                />
                                <label className="custom-control-label"
                                       htmlFor="input-welcome-cb">
                                    {commonStrings.send_welcome_email}
                                </label>
                            </div>
                        </FormGroup>
                        <small className="mt--2">
                            <i>{commonStrings.send_welcome_email_expl}</i>
                        </small>

                        {this.state.welcome_email_settings.is_enabled &&
                            <FormGroup className="mt-4">
                                <label
                                    className="form-control-label"
                                    htmlFor="input-custom-message"
                                >{commonStrings.welcome_email_custom_message}</label>
                                <Input
                                    className="form-control-alternative"
                                    id="input-custom-message"
                                    placeholder={commonStrings.welcome_email_custom_message_expl}
                                    onChange={this.handleChange}
                                    defaultValue={this.state.welcome_email_settings.active_text}
                                    rows="4"
                                    type="textarea"
                                />

                                {this.state.welcomeSettingsChanged &&
                                    <div className="text-right">
                                        <Button style={{marginTop: 20}} size="lg" color="success"
                                                onClick={e => this.updateWelcomeEmailText(e)}>
                                            {commonStrings.save}
                                        </Button>
                                    </div>
                                }

                            </FormGroup>
                        }

                    </div>
                </Card>

                {/*EXP TICKETS*/}
                <Card className="shadow bg-default" style={sectionStyle}>
                    <div style={{color: "white"}}>
                        <FormGroup>
                            <div className="custom-control custom-checkbox mt-4"
                            >
                                <input
                                    className="custom-control-input"
                                    id="input-exp-ticket-cb"
                                    type="checkbox"
                                    onChange={this.handleChange}
                                    checked={this.state.exp_ticket_settings.is_enabled}
                                />
                                <label className="custom-control-label"
                                       htmlFor="input-exp-ticket-cb">
                                    {commonStrings.send_exp_ticket_email}
                                </label>
                            </div>
                        </FormGroup>
                        <small className="mt--2">
                            <i>{commonStrings.send_exp_ticket_email_expl}</i>
                        </small>

                    </div>
                </Card>

            </LoadingOverlay>
        )
    }

    updateWelcomeEmailText(e) {
        e.preventDefault();
        businessApiService.updateWelcomeCustomText(this.state.welcome_email_settings.active_text, this.state.welcome_email_settings.id)
            .then(res => {
                this.processResponse(res)
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    toggleMessageModal = state => {
        this.setState({
            showMessageModal: !this.state.showMessageModal
        });
    };

    toggleMessageHistoryView = state => {
        if (!this.state.showMessageHistoryView) this.loadMessages()

        this.setState({
            showMessageHistoryView: !this.state.showMessageHistoryView
        });
    }

    renderSendMessageModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showMessageModal}
                toggle={() => this.toggleMessageModal("formModal")}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        {/*Your attention is required*/}
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleMessageModal("notificationModal")}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>

                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{commonStrings.send_message}</h4>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <div className="text-center text-muted mt--2 mb-4">
                                <small>{resourceStrings.cabinet.messaging_app_send_all_expl}</small>
                            </div>
                            <Form role="form">
                                <FormGroup className="mb-3">
                                    <InputGroup className="input-group-alternative">
                                        <Input placeholder={resourceStrings.title} type="text"
                                               id="message-input-title"
                                               defaultValue={this.state.message.title}
                                               onChange={this.handleMessageInputChange}/>
                                    </InputGroup>
                                </FormGroup>
                                <FormGroup>
                                    <InputGroup className="input-group-alternative">
                                        <Input placeholder={commonStrings.message}
                                               type="textarea" rows="5"
                                               id="message-input-text"
                                               defaultValue={this.state.message.message}
                                               onChange={this.handleMessageInputChange}/>
                                    </InputGroup>
                                </FormGroup>

                                <div className="custom-control custom-control-alternative custom-checkbox"
                                     style={{marginTop: 10}}>
                                    <input
                                        className="custom-control-input"
                                        id="input-to-all-active-cb"
                                        color="success"
                                        checked={this.state.filters.to_all_active_on}
                                        onChange={this.handleChange}
                                        type="checkbox"
                                    />
                                    <label className="custom-control-label" htmlFor="input-to-all-active-cb">
                                        {resourceStrings.cabinet.messaging_app_invite_to_active}
                                    </label>
                                </div>

                                <div className="custom-control custom-control-alternative custom-checkbox"
                                     style={{marginTop: 10}}>
                                    <input
                                        className="custom-control-input"
                                        id="input-to-all-all-cb"
                                        color="success"
                                        checked={this.state.filters.to_all_all_on}
                                        onChange={this.handleChange}
                                        type="checkbox"
                                    />
                                    <label className="custom-control-label" htmlFor="input-to-all-all-cb">
                                        {resourceStrings.cabinet.messaging_app_invite_to_all}
                                    </label>
                                </div>


                                <div className="text-center">
                                    {this.state.message && this.state.message.message && this.state.message.message.length > 10 &&
                                        <Button
                                            className="my-4"
                                            color="primary"
                                            type="button"
                                            onClick={e => this.sendMessageAction(e)}
                                        >
                                            {commonStrings.send}
                                        </Button>
                                    }
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    handleMessageInputChange(event) {
        this.setState({
            profileWasUpdated: true,
        });

        let newValue = event.target.value;
        let targetId = event.target.id;

        switch (targetId) {
            case "message-input-title":
                this.setState(prevState => ({
                    message: {
                        ...prevState.message,
                        title: newValue
                    }
                }));
                break;
            case "message-input-text":
                this.setState(prevState => ({
                    message: {
                        ...prevState.message,
                        message: newValue
                    }
                }));
                break;
            default:
                return
        }
    }

    sendMessageAction(event) {
        this.toggleMessageModal()
        event.preventDefault();
        this.setState({isLoading: true})

        const params = {
            send_to_all: this.state.filters.to_all_all_on,
            title: this.state.message.title,
            message: this.state.message.message
        }

        businessApiService.sendMessageToAll(params)
            .then(res => {
                res.message.toLowerCase() == "ok" ?
                    this.setState({
                        messageSent: true
                    })
                    :
                    this.handleNetworkError({message: res.message})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            })
            .finally(() => this.setState({isLoading: false}));
    }

    loadMessages() {
        businessApiService.businessMessages()
            .then(response => {
                this.setState({messages: response})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            })
            .finally(() => this.setState({isLoading: false}));
    }

    sendAppInviteMessage(e) {
        e.preventDefault();
        this.setState({isLoading: true})

        const params = {
            send_to_all: this.state.filters.app_invite_all_on
        }

        businessApiService.sendAppInviteMessage(params)
            .then(res => {
                res.message.toLowerCase() == "ok" ?
                    this.setState({
                        appInviteSent: true
                    })
                    :
                    this.handleNetworkError({message: res.message})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            })
            .finally(
                this.setState({
                    isLoading: false,
                })
            );
    }

    updateWelcomeEmailPrefs(checked) {
        businessApiService.updateWelcomeEmailPrefs(checked, this.state.welcome_email_settings.id)
            .then(res => {
                this.processResponse(res)
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    updateExpTicketEmailPrefs(checked) {
        businessApiService.updateExpTicketEmailPrefs(checked, this.state.exp_ticket_settings.id)
            .then(res => {
                this.processResponse(res)
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    handleChange(event) {
        let newValue = event.target.value;
        let targetId = event.target.id;
        let checkBoxValue = event.target.checked;
        console.log(checkBoxValue)

        switch (targetId) {
            case "input-custom-message":
                this.setState(prevState => ({
                    welcomeSettingsChanged: true,
                    welcome_email_settings: {
                        ...prevState.welcome_email_settings,
                        active_text: newValue,
                    }
                }));
                break;
            case "input-welcome-cb":
                this.updateWelcomeEmailPrefs(checkBoxValue);
                break;
            case "input-exp-ticket-cb":
                this.updateExpTicketEmailPrefs(checkBoxValue);
                break;
            case "input-app-invite-all-cb":
                this.setState(prevState => ({
                    filters: {
                        ...prevState.filters,
                        app_invite_all_on: checkBoxValue,
                        app_invite_active_on: !checkBoxValue
                    }
                }));
                break;
            case "input-app-invite-active-cb":
                this.setState(prevState => ({
                    filters: {
                        ...prevState.filters,
                        app_invite_all_on: !checkBoxValue,
                        app_invite_active_on: checkBoxValue
                    }
                }));
                break;
            case "input-to-all-all-cb":
                this.setState(prevState => ({
                    filters: {
                        ...prevState.filters,
                        to_all_all_on: checkBoxValue,
                        to_all_active_on: !checkBoxValue
                    }
                }));
                break;
            case "input-to-all-active-cb":
                this.setState(prevState => ({
                    filters: {
                        ...prevState.filters,
                        to_all_all_on: !checkBoxValue,
                        to_all_active_on: checkBoxValue
                    }
                }));
                break;
        }
    }

    handleBdSettingsChange(event) {
        let newValue = event.target.value;
        let targetId = event.target.id;
        let checkBoxValue = event.target.checked;
        console.log(checkBoxValue)

        this.setState({bdSettingsChanged: true})

        switch (targetId) {
            case "input-bd-active-cb":
                this.setState(prevState => ({
                    bd_settings: {
                        ...prevState.bd_settings,
                        to_active: checkBoxValue,
                        to_all: checkBoxValue ? !checkBoxValue : this.state.bd_settings.to_all
                    }
                }));
                break;
            case "input-bd-all-cb":
                this.setState(prevState => ({
                    bd_settings: {
                        ...prevState.bd_settings,
                        to_all: checkBoxValue,
                        to_active: checkBoxValue ? !checkBoxValue : this.state.bd_settings.to_active
                    }
                }));
                break;
            case "input-bd-message-to-active":
                this.setState(prevState => ({
                    bd_settings: {
                        ...prevState.bd_settings,
                        active_text: newValue,
                    }
                }));
                break;
            case "input-bd-message-to-inactive":
                this.setState(prevState => ({
                    bd_settings: {
                        ...prevState.bd_settings,
                        inactive_text: newValue,
                    }
                }));
                break;
        }
    }

    handleClassReminderSettingsChange(event) {
        let checkBoxValue = event.target.checked;
        console.log(checkBoxValue)

        this.setState({isLoading: true})

        let classReminderSettings = this.state.classReminderSettings
        classReminderSettings.is_enabled = checkBoxValue

        this.setState(prevState => ({
            classReminderSettings: classReminderSettings
        }));

        businessApiService.saveClassReminderSettings(classReminderSettings)
            .then(res => {
                this.processResponse(res)
            })
            .catch((e) => {
                this.handleNetworkError(e)
            })
            .finally(() => this.setState({isLoading: false}));
    }

    handleClassRegistrationSettings(event) {
        let checkBoxValue = event.target.checked;
        console.log(checkBoxValue)

        this.setState({isLoading: true})

        let classRegistrationSettings = this.state.classRegistrationSettings
        classRegistrationSettings.is_enabled = checkBoxValue

        this.setState(prevState => ({
            classRegistrationSettings: classRegistrationSettings
        }));

        businessApiService.saveClassRegistrationSettings(classRegistrationSettings)
            .then(res => {
                this.processResponse(res)
            })
            .catch((e) => {
                this.handleNetworkError(e)
            })
            .finally(() => this.setState({isLoading: false}));
    }

    goToClass(e, item) {
        e.preventDefault();
        this.setState({goToClassId: item.yclass_id})
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        reportStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    reportName() {
        return resourceStrings.cabinet.cashier
    }

    getData() {
        this.setState({isLoading: true});

        businessApiService.getMessageSettings()
            .then(res => {
                this.processResponse(res)
            })
            .catch((e) => {
                this.handleNetworkError(e)
            })
            .finally(() => this.setState({isLoading: false}));
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    updateItem(item, yclasses, students) {
        if (item && item.student_id && !item.anonymous) {
            if (students) {

                let client = students.find((s) => {
                    return s.id == item.student_id
                })
                if (client) {
                    item.client_name = client.name
                    item.client_photo = client.photo
                }
            }
        }

        if (item && item.yclass_id && yclasses) {
            let yclass = yclasses.find((y) => {
                return y.id == item.yclass_id
            })
            if (yclass) {
                item.yclass = yclass
            }
        }

        return item
    }

    canSaveBdSettings() {
        return this.state.bd_settings && this.state.bd_settings.active_text && this.state.bdSettingsChanged
    }

    saveBdChanges(e) {
        e.preventDefault();

        businessApiService.saveBdSettings(this.state.bd_settings)
            .then(res => {
                this.processResponse(res)
            })
            .catch((e) => {
                this.handleNetworkError(e)
            })
            .finally(() => this.setState({isLoading: false}));
    }

    processResponse(res) {
        let bdSettings = resourceHelper.emptyBdSettings();
        let classReminderSettings = resourceHelper.emptyClassReminderSettings();
        let classRegistrationSettings = resourceHelper.emptyClassRegistrationSettings();
        let welcomeSettings = resourceHelper.emptyWelcomeSettings();
        let expTicketsSettings = resourceHelper.emptyExpTicketsSettings();

        if (res && res.length > 0) {
            bdSettings = res.find((s) => {
                return s.message_type == "bd"
            })

            welcomeSettings = res.find((s) => {
                return s.message_type == "welcome_email"
            })

            classReminderSettings = res.find((s) => {
                return s.message_type == "class_reminders"
            })

            expTicketsSettings = res.find((s) => {
                return s.message_type == "exp_ticket"
            })

            classRegistrationSettings = res.find((s) => {
                return s.message_type == "class_registration"
            })
        }

        this.setState({
            classReminderSettings: classReminderSettings || resourceHelper.emptyClassReminderSettings(),
            classRegistrationSettings: classRegistrationSettings || resourceHelper.emptyClassRegistrationSettings(),
            bd_settings: bdSettings || resourceHelper.emptyBdSettings(),
            bdSettingsChanged: false,
            welcome_email_settings: welcomeSettings || resourceHelper.emptyWelcomeSettings(),
            welcomeSettingsChanged: false,
            exp_ticket_settings: expTicketsSettings || resourceHelper.emptyExpTicketsSettings(),
            expTicketsSettingsChanged: false,
        })
    }
}

